/**
 * Validates that `path` is a bare same-origin path (e.g. "/points").
 * Rejects absolute URLs and schemaless URLs ("//evil.com") to prevent
 * open-redirect via ?redirect= on /login.
 *
 * @param {unknown} path
 * @returns {boolean}
 */
export function isSafePath(path) {
  if (typeof path !== 'string' || path.length === 0) return false
  if (!path.startsWith('/') || path.startsWith('//')) return false
  try {
    const parsed = new URL(path, window.location.origin)
    return parsed.origin === window.location.origin
  } catch {
    return false
  }
}

export const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect'
export const SOCIAL_LOGIN_STORAGE_KEY = 'socialLogInCode'

/**
 * Persists a validated post-login redirect path into sessionStorage so that
 * the vuex `afterLoginSuccess` action can consume it after the auth round-trip.
 * Absolute URLs and schemaless URLs are silently dropped.
 */
export function storePostLoginRedirect(path) {
  if (!isSafePath(path)) return
  try {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path)
  } catch {
    /* sessionStorage disabled — fall back to default post-login routing */
  }
}

/**
 * Reads and clears the post-login redirect path. Returns '' when no safe path
 * is stored (invalid values are treated as absent and cleared).
 */
export function consumePostLoginRedirect() {
  let raw
  try {
    raw = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
  } catch {
    return ''
  }
  return isSafePath(raw) ? raw : ''
}
